/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} League_Meta_BadgeInputs */



/**
* | output |
* | --- |
* | "Meta" |
*
* @param {League_Meta_BadgeInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const league_meta_badge = /** @type {((inputs?: League_Meta_BadgeInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<League_Meta_BadgeInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Méta")
	if (locale === "es") return /** @type {LocalizedString} */ ("Meta")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Meta")
	if (locale === "it") return /** @type {LocalizedString} */ ("Meta")
	return /** @type {LocalizedString} */ ("Meta")
});